export const firebaseConfig = {
  apiKey: 'AIzaSyAiktvVa0-09Hw6-WOCnG3WDC3W8N69GKM',
  authDomain: 'concert-management.firebaseapp.com',
  projectId: 'concert-management',
  storageBucket: 'concert-management.appspot.com',
  messagingSenderId: '346152780736',
  appId: '1:346152780736:web:37d4a7a4e3e4c2804cbe25',
};
